import { ArrowLeftIcon } from 'lucide-react';

import {
  Button,
  MobileMenuItem,
  MobileMenuLabel,
  MobileMenuSeparator,
  MobileMenuStackScreenContent,
  useMobileMenu,
  useSimpleStackNavigator,
} from '@crossnokaye/ux-common/ckds';

import { EquipmentBrowserSection } from '@repo/sdk/models/components';

import { JUMP_TO_MENU_ID } from './constants';
import { JumpToEquipmentReturn } from '../useJumpToEquipment';

interface JumpToEquipmentScreenProps extends JumpToEquipmentReturn {
  section: EquipmentBrowserSection;
}

export const JumpToEquipmentScreen = ({
  section,
  getEquipmentBySection,
  handleEquipmentClick,
}: JumpToEquipmentScreenProps) => {
  const { popScreen } = useSimpleStackNavigator();
  const { close } = useMobileMenu(JUMP_TO_MENU_ID);

  return (
    <MobileMenuStackScreenContent
      stickyBottom={
        <>
          <div className="flex gap-2 px-inline-sm pb-inline-sm pt-2.5">
            <Button
              variant="inverse"
              className="flex-1"
              leftIcon={ArrowLeftIcon}
              onClick={popScreen}
            >
              Equipment Menu
            </Button>
          </div>
        </>
      }
    >
      <MobileMenuLabel>{section.name}</MobileMenuLabel>
      <MobileMenuSeparator />

      {getEquipmentBySection(section)?.map((equipment) => (
        <MobileMenuItem
          onClick={() => {
            handleEquipmentClick(equipment, section);
            close();
          }}
        >
          {equipment.title}
        </MobileMenuItem>
      ))}
    </MobileMenuStackScreenContent>
  );
};
